module.exports = __webpack_public_path__ + "static/media/follower.e735399d.png";